import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { KpiCard, C, BG } from "../analisis/comun";
import { getServicioStyle } from "../../utils/servicioColores";

// Etiqueta de servicio con los colores comunes de toda la app (utils/servicioColores).
const ServicioTag = ({ servicio }) => {
  const sc = getServicioStyle(servicio);
  return (
    <span style={{ ...s.servicioTag, background: sc.bg, color: sc.color, border: `1px solid ${sc.border}` }}>
      {servicio}
    </span>
  );
};

const hoyISO = () => new Date().toISOString().slice(0, 10);

const nombreCompleto = (sup) => [sup.nombre, sup.apellidos].filter(Boolean).join(" ").trim();
const COLORES_AVATAR = ["#4f46e5", "#0891b2", "#db2777", "#ea580c", "#16a34a", "#7c3aed", "#0d9488", "#b45309"];
const colorAvatar = (user) => COLORES_AVATAR[[...String(user)].reduce((a, ch) => a + ch.charCodeAt(0), 0) % COLORES_AVATAR.length];
const Avatar = ({ sup, size = 34 }) => (
  <span style={{
    width: size, height: size, borderRadius: "50%", flexShrink: 0, display: "inline-flex", alignItems: "center", justifyContent: "center",
    background: colorAvatar(sup.user), color: "#fff", fontWeight: 800, fontSize: size * 0.42,
  }}>{(nombreCompleto(sup) || sup.user).charAt(0).toUpperCase()}</span>
);

// Desplegable de supervisoras con buscador: avatar + nombre completo + usuario entero.
const SelectorSupervisora = ({ supervisoras, valor, onChange, cargando }) => {
  const [abierto, setAbierto] = useState(false);
  const [busqueda, setBusqueda] = useState("");
  const ref = useRef(null);
  useEffect(() => {
    if (!abierto) return;
    const fuera = (e) => { if (ref.current && !ref.current.contains(e.target)) setAbierto(false); };
    document.addEventListener("mousedown", fuera);
    document.addEventListener("touchstart", fuera);
    return () => { document.removeEventListener("mousedown", fuera); document.removeEventListener("touchstart", fuera); };
  }, [abierto]);
  const actual = supervisoras.find((x) => x.user === valor);
  const q = busqueda.trim().toLowerCase();
  const lista = q ? supervisoras.filter((x) => `${nombreCompleto(x)} ${x.user}`.toLowerCase().includes(q)) : supervisoras;
  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button type="button" disabled={cargando} onClick={() => { setAbierto((a) => !a); setBusqueda(""); }} style={{
        ...s.selectorBtn, borderColor: abierto ? "#6366f1" : "#c7d2fe", boxShadow: abierto ? "0 0 0 3px rgba(99,102,241,0.18)" : s.selectorBtn.boxShadow,
      }}>
        {actual ? (
          <>
            <Avatar sup={actual} />
            <span style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", minWidth: 0, flex: 1 }}>
              <span style={{ fontWeight: 800, color: "#1e293b", fontSize: 15, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100%" }}>{nombreCompleto(actual) || actual.user}</span>
              <span style={{ fontSize: 12.5, color: "#6366f1", fontWeight: 700 }}>@{actual.user}</span>
            </span>
          </>
        ) : (
          <span style={{ flex: 1, textAlign: "left", color: "#64748b", fontWeight: 600 }}>{cargando ? "Cargando…" : "👩‍💼 Selecciona una supervisora…"}</span>
        )}
        <span style={{ color: "#6366f1", fontSize: 14, transition: "transform .2s", transform: abierto ? "rotate(180deg)" : "none" }}>▾</span>
      </button>
      {abierto && (
        <div style={s.selectorPanel}>
          <input autoFocus value={busqueda} onChange={(e) => setBusqueda(e.target.value)} placeholder="🔍 Buscar por nombre o usuario…" style={s.selectorBuscar} />
          <div style={{ maxHeight: 320, overflowY: "auto", marginTop: 6 }}>
            {lista.length === 0 && <div style={{ padding: 14, color: "#94a3b8", fontSize: 13.5, textAlign: "center" }}>Sin resultados</div>}
            {lista.map((sup) => {
              const sel = sup.user === valor;
              return (
                <button key={sup.user} type="button" onClick={() => { onChange(sup.user); setAbierto(false); }} style={{
                  ...s.selectorItem, background: sel ? "#eef2ff" : "transparent",
                }}
                  onMouseEnter={(e) => { if (!sel) e.currentTarget.style.background = "#f8fafc"; }}
                  onMouseLeave={(e) => { if (!sel) e.currentTarget.style.background = "transparent"; }}>
                  <Avatar sup={sup} size={32} />
                  <span style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", flex: 1, minWidth: 0 }}>
                    <span style={{ fontWeight: 700, color: "#1e293b", fontSize: 14.5 }}>{nombreCompleto(sup) || sup.user}</span>
                    <span style={{ fontSize: 12.5, color: "#64748b" }}>@{sup.user}</span>
                  </span>
                  {sel && <span style={{ color: "#4f46e5", fontWeight: 900 }}>✓</span>}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

const fmtDur = (min) => {
  if (min == null) return "";
  const h = Math.floor(min / 60), m = min % 60;
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
};

// Contenido del panel de ruta DIARIA (sin cabecera de página), reutilizable dentro de «Ruta»:
//  - supervisoraFija: usuario de la supervisora (modo «Mi Ruta»): sin selector, solo se elige el día.
//  - supervisora / onSupervisora: selección controlada desde fuera (admins); si no se pasan, se gestiona aquí dentro.
export const RutaDiaContenido = ({ supervisoraFija = null, supervisora: supControlada, onSupervisora }) => {
  const [supervisoras, setSupervisoras] = useState([]);
  const [supInterna, setSupInterna] = useState("");
  const supervisora = supervisoraFija || (supControlada !== undefined ? supControlada : supInterna);
  const setSupervisora = (u) => { if (onSupervisora) onSupervisora(u); else setSupInterna(u); };
  const [fecha, setFecha] = useState(hoyISO());
  const [data, setData] = useState(null);
  const [loadingLista, setLoadingLista] = useState(!supervisoraFija);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (supervisoraFija) return;
    axios.get("/api/seguimiento-supervisoras/mis-supervisoras")
      .then((r) => setSupervisoras(r.data?.supervisoras || []))
      .catch(() => setError("Error al cargar la lista de supervisoras."))
      .finally(() => setLoadingLista(false));
  }, [supervisoraFija]);

  const cargarRuta = useCallback(() => {
    if (!supervisora || !fecha) return;
    setLoading(true);
    setError("");
    axios.get("/api/seguimiento-supervisoras/ruta", { params: { supervisora, fecha } })
      .then((r) => setData(r.data))
      .catch((e) => { setError(e.response?.data?.error || "Error al cargar la ruta."); setData(null); })
      .finally(() => setLoading(false));
  }, [supervisora, fecha]);

  useEffect(() => { cargarRuta(); }, [cargarRuta]);

  // Timeline: paradas (fichaje de entrada y de salida) intercaladas con el desplazamiento: salida del piso anterior → entrada de este.
  const timeline = useMemo(() => {
    if (!data?.paradas?.length) return [];
    const out = [];
    data.paradas.forEach((p, i) => {
      if (i > 0) out.push({ tipo: "dur", min: p.desplazamiento_min, reporte: p.origen === "reporte", sinSalida: !data.paradas[i - 1].fecha_hora_salida });
      out.push({ tipo: "parada", p });
    });
    return out;
  }, [data]);

  const RUTA_LABEL = { 1: "Ruta 1 (lun/jue)", 2: "Ruta 2 (mar/vie)", 3: "Ruta 3 (según organización)" };

  const moverDia = (n) => {
    const d = new Date(fecha + "T00:00:00"); d.setDate(d.getDate() + n);
    const nuevo = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    if (nuevo <= hoyISO()) setFecha(nuevo);
  };

  return (
      <div style={s.content}>
        <div style={s.controles}>
          {!supervisoraFija && (
            <div style={{ flex: 1, minWidth: 200 }}>
              <label style={s.label}>Supervisora</label>
              <SelectorSupervisora
                supervisoras={supervisoras}
                valor={supervisora}
                cargando={loadingLista}
                onChange={(u) => { setSupervisora(u); setData(null); }}
              />
            </div>
          )}
          <div>
            <label style={s.label}>Día</label>
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <button type="button" onClick={() => moverDia(-1)} title="Día anterior" style={s.flechaDia}>◀</button>
              <input
                type="date"
                value={fecha}
                max={hoyISO()}
                onChange={(e) => e.target.value && setFecha(e.target.value)}
                style={{ ...s.select, minHeight: 52 }}
              />
              <button type="button" onClick={() => moverDia(1)} disabled={fecha >= hoyISO()} title="Día siguiente" style={{ ...s.flechaDia, opacity: fecha >= hoyISO() ? 0.35 : 1 }}>▶</button>
            </div>
          </div>
        </div>

        {!supervisora ? (
          <div style={s.vacio}>
            <div style={{ fontSize: 40, marginBottom: 8 }}>🗺️</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: "#475569" }}>Elige una supervisora para ver su ruta</div>
          </div>
        ) : loading ? (
          <p style={{ textAlign: "center", color: "#64748b", padding: 40, fontSize: 16 }}>Cargando…</p>
        ) : error ? (
          <div style={s.errorBox}>{error}</div>
        ) : data && (
          <>
            {/* ── Resumen ── */}
            <div style={s.card}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14, flexWrap: "wrap", gap: 8 }}>
                <h3 style={s.sectionTitle}>📊 Análisis del día</h3>
                {(data.rutas_del_dia?.length || data.ruta_del_dia != null) ? (
                  <span style={s.badgeRuta}>{(data.rutas_del_dia?.length ? data.rutas_del_dia : [data.ruta_del_dia]).map((r) => RUTA_LABEL[r] || `Ruta ${r}`).join(" + ")}</span>
                ) : (
                  <span style={{ ...s.badgeRuta, background: BG.gris, color: C.gris }}>Sin ruta obligatoria (fin de semana)</span>
                )}
              </div>
              <div style={s.kpiGrid}>
                <KpiCard icon="📋" label="Pisos de la ruta" value={data.resumen.total_esperados} bg={BG.indigo} color={C.indigo} />
                <KpiCard icon="✅" label="Visitados" value={data.resumen.visitados} bg={BG.gris} color="#1e293b" />
                <KpiCard icon="🟢" label="A tiempo" value={data.resumen.a_tiempo} bg={BG.verde} color={C.verde} />
                <KpiCard icon="🔴" label="Fuera de tiempo" value={data.resumen.fuera_tiempo} bg={BG.rojo} color={C.rojo} />
                <KpiCard
                  icon="⏱️"
                  label="Retraso medio"
                  value={data.resumen.retraso_medio_minutos != null ? `${data.resumen.retraso_medio_minutos} min` : "—"}
                  bg={BG.amarillo} color={C.amarillo}
                />
                <KpiCard icon="✨" label="Extras" value={data.resumen.extras} bg="#f3e8ff" color="#7c3aed" />
                {data.resumen.origen === "fichaje" && data.resumen.reportes_hechos != null && <KpiCard icon="📝" label="Reportes hechos" value={data.resumen.reportes_hechos} bg={BG.verde} color={C.verde} />}
                {data.resumen.origen === "fichaje" && data.resumen.reportes_retrasados != null && <KpiCard icon="⏳" label="Reportes retrasados" value={data.resumen.reportes_retrasados} bg={BG.rojo} color={C.rojo} />}
                {data.resumen.origen === "fichaje" && data.resumen.visitados_sin_reporte != null && <KpiCard icon="📝" label="Pisos visitados sin reporte" value={data.resumen.visitados_sin_reporte} bg={BG.rojo} color={C.rojo} />}
                {data.resumen.origen === "fichaje" && <KpiCard icon="🏠" label="Tiempo en pisos" value={data.resumen.minutos_en_pisos != null ? fmtDur(data.resumen.minutos_en_pisos) : "—"} bg={BG.azul} color={C.azul} />}
                {data.resumen.origen === "fichaje" && <KpiCard icon="🚶" label="Desplazamiento medio" value={data.resumen.desplazamiento_medio_min != null ? fmtDur(data.resumen.desplazamiento_medio_min) : "—"} bg={BG.gris} color="#1e293b" />}
              </div>
            </div>

            {/* ── Pendientes ── */}
            {data.pendientes.length > 0 && (
              <div style={{ ...s.card, background: BG.rojo, border: `1.5px solid ${C.rojo}` }}>
                <h3 style={{ ...s.sectionTitle, color: C.rojo }}>⬜ Le queda por visitar ({data.pendientes.length})</h3>
                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  {data.pendientes.map((p) => (
                    <div key={p.id_piso} style={s.pendienteRow}>
                      <div>
                        <strong>{p.abreviatura}</strong>
                        {p.servicio && <ServicioTag servicio={p.servicio} />}
                      </div>
                      <div style={{ fontSize: 12.5, color: "#7f1d1d" }}>
                        Asistenta {p.asistenta || "—"} · horario {p.hora_entrada || "—"}–{p.hora_salida || "—"}
                        <span title="Alumnos del piso: A / R" style={s.chipAR}>👥 <b style={{ color: "#1d4ed8" }}>A {p.alumnos?.a ?? 0}</b> · <b style={{ color: "#b45309" }}>R {p.alumnos?.r ?? 0}</b></span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* ── Timeline ── */}
            <div style={s.card}>
              <h3 style={s.sectionTitle}>🗓️ Ruta realizada</h3>
              {timeline.length === 0 ? (
                <div style={{ color: "#94a3b8", fontSize: 14, textAlign: "center", padding: "20px 0" }}>
                  {data.resumen.origen === "fichaje" ? "Todavía no ha fichado en ningún piso ese día." : "Todavía no ha enviado ningún reporte ese día."}
                </div>
              ) : (
                <div style={s.timelineWrap}>
                  <div style={s.verticalLine} />
                  {timeline.map((el, idx) => {
                    if (el.tipo === "dur") {
                      return (
                        <div key={`d${idx}`} style={s.durRow}>
                          <div style={s.dotCol} />
                          <div style={!el.reporte && el.min != null ? s.durChipDesp : s.durChip} title="Desde el fichaje de salida del piso anterior hasta el de entrada a este">
                            {el.reporte ? `⏱ ${fmtDur(el.min)}` : el.min != null ? `🚶 ${fmtDur(el.min)} de desplazamiento` : el.sinSalida ? "🚶 sin fichaje de salida del piso anterior" : "🚶 —"}
                          </div>
                        </div>
                      );
                    }
                    const p = el.p;
                    const color = p.en_horario === true ? C.verde : p.en_horario === false ? C.rojo : C.gris;
                    const bg = p.en_horario === true ? BG.verde : p.en_horario === false ? BG.rojo : BG.gris;
                    return (
                      <div key={p.id_fichaje} style={s.parada}>
                        <div style={s.dotCol}>
                          <div style={{ ...s.dot, background: color, boxShadow: `0 0 0 3px ${bg}` }} />
                        </div>
                        <div style={{ flex: 1 }}>
                          <div style={{ display: "flex", alignItems: "baseline", gap: 10, flexWrap: "wrap" }}>
                            <strong style={{ fontSize: 15 }}>{p.abreviatura}</strong>
                            {p.servicio && <ServicioTag servicio={p.servicio} />}
                            {p.es_extra && <span style={s.badgeExtra}>✨ EXTRA</span>}
                          </div>
                          <div style={{ display: "flex", alignItems: "baseline", gap: 8, flexWrap: "wrap", marginTop: 3 }}>
                            {p.origen === "reporte" ? (
                              <span title="Hora del reporte" style={s.hora}>🕐 {p.hora_reporte} <span style={{ fontSize: 12, fontWeight: 600, color: "#64748b" }}>(reporte)</span></span>
                            ) : (<>
                              {/* una línea por cada hora, en orden: entrada · reporte(s) · salida */}
                              <div style={{ display: "flex", flexDirection: "column", gap: 3, width: "100%" }}>
                                {(() => {
                                  const ev = [{ t: p.fecha_hora, k: "e", tx: <span title="Fichaje de entrada" style={s.hora}>▶ Entrada {p.hora_entrada_fichaje}</span> }];
                                  (p.reportes || []).forEach((r, ri) => ev.push({ t: r.fecha_hora, k: `r${ri}`, tx: (
                                    <span title={r.fuera ? "Reporte enviado fuera del tiempo fichado en este piso (más de 10 min después de la salida)" : "Hora del reporte"} style={{ ...s.hora, ...(r.fuera ? { color: C.rojo } : {}) }}>
                                      📝 Reporte {r.hora}{r.fuera && <span style={{ fontSize: 12, fontWeight: 800 }}> ⚠️ fuera del fichaje</span>}
                                    </span>) }));
                                  if (p.fecha_hora_salida) ev.push({ t: p.fecha_hora_salida, k: "s", tx: <span title="Fichaje de salida" style={s.hora}>⏹ Salida {p.hora_salida_fichaje}{p.salida_otro_dia ? " (día siguiente)" : ""}</span> });
                                  if (p.fecha_hora_salida && p.minutos_en_piso != null) ev.push({ t: p.fecha_hora + "~", k: "t", tx: <span title="Tiempo en el piso: de la entrada a la salida" style={s.chipTiempo}>🏠 {fmtDur(p.minutos_en_piso)} en el piso</span> });      // justo tras la entrada, en su línea
                                  ev.sort((x, y) => (x.t < y.t ? -1 : x.t > y.t ? 1 : 0));
                                  return ev.map((x) => <div key={x.k}>{x.tx}</div>);
                                })()}
                                {!p.fecha_hora_salida && <div><span title="Fichaje de salida" style={s.hora}>⏹ <span style={{ color: "#b45309", fontWeight: 700, fontSize: 13 }}>sin fichar salida</span></span></div>}
                                {!(p.reportes || []).length && <div><span title="Reporte" style={{ ...s.hora, color: "#b91c1c", fontWeight: 700 }}>📝 sin reporte</span></div>}
                              </div>
                            </>)}
                          </div>
                          <div style={{ fontSize: 12.5, color: "#64748b", marginTop: 2 }}>
                            Asistenta {p.asistenta || "—"} · horario {p.hora_entrada || "—"}–{p.hora_salida || "—"}
                        <span title="Alumnos del piso: A / R" style={s.chipAR}>👥 <b style={{ color: "#1d4ed8" }}>A {p.alumnos?.a ?? 0}</b> · <b style={{ color: "#b45309" }}>R {p.alumnos?.r ?? 0}</b></span>
                          </div>
                          {p.en_horario === false && (
                            <div style={{ fontSize: 12.5, color: C.rojo, fontWeight: 700, marginTop: 2 }}>
                              {(() => {
                                const hr = p.origen === "reporte" ? p.hora_reporte : p.hora_entrada_fichaje;
                                const antes = hr < (p.hora_entrada || "");
                                return antes
                                  ? `⏰ ${p.origen === "reporte" ? "" : "Entra "}${p.retraso_minutos} min antes de la hora de entrada de la asistenta`
                                  : `⏰ ${p.origen === "reporte" ? "" : "Entra "}${p.retraso_minutos} min después de la hora de salida de la asistenta`;
                              })()}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
              {data.reportes_sin_fichaje?.length > 0 && (
                <div style={{ marginTop: 12, background: "#fef2f2", border: "1px solid #fca5a5", borderRadius: 12, padding: "10px 14px" }}>
                  <div style={{ fontWeight: 900, color: "#b91c1c", fontSize: 14 }}>📝 Reportes enviados sin fichar en el piso ({data.reportes_sin_fichaje.length})</div>
                  {data.reportes_sin_fichaje.map((r, i) => <div key={i} style={{ fontSize: 13.5, color: "#7f1d1d", marginTop: 3 }}><strong>{r.abreviatura || `piso ${r.id_piso}`}</strong> · reporte a las {r.hora}</div>)}
                </div>
              )}
            </div>
          </>
        )}
      </div>
  );
};

// Página completa (la de siempre): cabecera + contenido.
const SeguimientoRutaSupervisora = () => {
  const navigate = useNavigate();
  return (
    <div style={s.page}>
      <div style={s.header}>
        <button onClick={() => navigate(-1)} style={s.btnVolver}>← Volver</button>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 14, color: "rgba(255,255,255,0.55)" }}>Servicios</div>
          <strong style={{ fontSize: 22, color: "#fff" }}>🗺️ Ver ruta supervisora</strong>
        </div>
      </div>
      <RutaDiaContenido />
    </div>
  );
};

const s = {
  page: { minHeight: "100vh", background: "#f0f4f8", fontFamily: "Segoe UI, sans-serif", paddingBottom: 40 },
  header: { background: "linear-gradient(135deg,#1e293b,#0f172a)", color: "#fff", padding: "20px 24px", display: "flex", alignItems: "center", gap: 16 },
  btnVolver: { background: "rgba(255,255,255,0.15)", border: "none", borderRadius: 10, color: "#fff", fontWeight: 700, fontSize: 14, cursor: "pointer", padding: "10px 16px", whiteSpace: "nowrap" },
  content: { padding: 24, maxWidth: 780, margin: "0 auto", display: "flex", flexDirection: "column", gap: 16 },
  controles: { display: "flex", gap: 14, flexWrap: "wrap", alignItems: "flex-end" },
  label: { display: "block", fontSize: 13, fontWeight: 700, color: "#334155", marginBottom: 4 },
  selectorBtn: {
    display: "flex", alignItems: "center", gap: 10, width: "100%", minHeight: 52, padding: "8px 14px", boxSizing: "border-box",
    borderRadius: 14, border: "2px solid #c7d2fe", background: "linear-gradient(135deg,#fff,#eef2ff)", cursor: "pointer",
    boxShadow: "0 2px 8px rgba(79,70,229,0.12)", fontSize: 14, textAlign: "left",
  },
  selectorPanel: {
    position: "absolute", top: "calc(100% + 6px)", left: 0, right: 0, zIndex: 50, background: "#fff", borderRadius: 14,
    border: "1.5px solid #e0e7ff", boxShadow: "0 12px 32px rgba(15,23,42,0.18)", padding: 8,
  },
  selectorBuscar: {
    width: "100%", boxSizing: "border-box", padding: "10px 12px", borderRadius: 10, border: "1.5px solid #e2e8f0", fontSize: 14, outline: "none",
  },
  selectorItem: {
    display: "flex", alignItems: "center", gap: 10, width: "100%", padding: "8px 10px", borderRadius: 10, border: "none",
    cursor: "pointer", textAlign: "left", transition: "background .12s",
  },
  flechaDia: { border: "none", background: "#eef2ff", borderRadius: 10, minHeight: 52, padding: "0 14px", cursor: "pointer", fontWeight: 900, color: "#3730a3", fontSize: 15 },
  chipAR: { marginLeft: 8, fontSize: 11.5, fontWeight: 700, color: "#334155", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 999, padding: "1px 9px", whiteSpace: "nowrap" },
  select: { padding: "10px 12px", borderRadius: 10, border: "1.5px solid #e2e8f0", fontSize: 14, background: "#fff", minWidth: 200, boxSizing: "border-box" },
  vacio: { background: "#fff", borderRadius: 18, boxShadow: "0 2px 10px rgba(15,23,42,0.06)", padding: "40px 20px", textAlign: "center" },
  errorBox: { background: BG.rojo, color: C.rojo, borderRadius: 10, padding: "12px 18px", fontSize: 14 },

  card: { background: "#fff", borderRadius: 18, boxShadow: "0 2px 12px rgba(15,23,42,0.07)", border: "1.5px solid #eef2f7", padding: "18px 20px" },
  sectionTitle: { fontSize: 16, fontWeight: 800, color: "#1e293b", margin: "0 0 14px 0" },
  badgeRuta: { background: BG.indigo, color: C.indigo, borderRadius: 20, padding: "4px 12px", fontSize: 13, fontWeight: 800 },
  kpiGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: 10 },

  pendienteRow: { display: "flex", justifyContent: "space-between", alignItems: "center", background: "#fff", borderRadius: 10, padding: "10px 14px", flexWrap: "wrap", gap: 4 },
  servicioTag: { marginLeft: 8, fontSize: 11.5, fontWeight: 700, color: "#475569", background: "#f1f5f9", borderRadius: 8, padding: "2px 8px" },

  timelineWrap: { position: "relative" },
  verticalLine: { position: "absolute", top: 6, bottom: 6, left: 11, width: 3, background: "linear-gradient(#94a3b8, #cbd5e1)", borderRadius: 2 },
  dotCol: { width: 24, minWidth: 24, display: "flex", alignItems: "center", justifyContent: "center" },
  dot: { width: 14, height: 14, borderRadius: "50%", flexShrink: 0 },
  parada: { position: "relative", display: "flex", alignItems: "flex-start", gap: 12, padding: "10px 0" },
  hora: { fontSize: 16, fontWeight: 800, color: "#1e293b" },
  chipTiempo: { fontSize: 14, fontWeight: 800, color: "#1d4ed8", background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 999, padding: "2px 12px" },
  durRow: { display: "flex", alignItems: "center", gap: 12, padding: "2px 0" },
  durChipDesp: { color: "#c2410c", background: "#fff7ed", display: "inline-block", padding: "3px 12px", borderRadius: 12, border: "1px solid #fdba74", fontSize: 14, fontWeight: 800 },
  durChip: { color: "#555", background: "#f1f5f9", display: "inline-block", padding: "2px 10px", borderRadius: 12, border: "1px solid #e2e8f0", fontSize: 12.5, fontWeight: 600 },
  badgeExtra: { background: BG.azul, color: C.azul, borderRadius: 20, padding: "2px 10px", fontSize: 11.5, fontWeight: 800 },
};

export default SeguimientoRutaSupervisora;
